import React from "react";
import Banner from "../../Componenets/BannerPage/Banner";
import GlobalAssets from "../../Componenets/Globalassets/GlobalAssets";
import Ourinvest from "../../Componenets/OurInvester/Ourinvest";
import { WhatsappTradings } from "../../Componenets/WhatsAppTrading/WhatsappTradings";
import { Discover } from "../../Componenets/Discovers/Discover";
import GlobalStage from "../../Componenets/Globalassets/GlobalStage";
import Wealth from "../../Componenets/Globalassets/Wealth";
import InvesterCards from "../../Componenets/InvesterCard/InvesterCards";
import OurAwards from "../../Componenets/OurAwards/OurAward";
import { Box } from "@mui/material";
import AnimatedCard from "../../Componenets/AnimatedCard";
import RiskModal from "../../Componenets/RiskModal";

const LandingPages = () => {
  return (
    <>
      <RiskModal /> {/* Add this line */}

      <Banner />
      <GlobalAssets />
      <Box px={{ xs: 2, sm: 3, md: 6, lg: 11 }}>
        <Ourinvest />
        <Box mb={5}>
          {/* <AnimatedCard /> */}
          <WhatsappTradings />
        </Box>
      </Box>
      <Discover />
      <InvesterCards />
      <GlobalStage />

      <Box px={{ xs: 2, sm: 3, md: 6, lg: 11 }}>


        <OurAwards />

      </Box>
      <Wealth />

    </>
  );
};

export default LandingPages;
